import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0101P4State, IDeptTreeState, IInquiryCndsState} from '../../models/com/com0101p4_model';
  
const initialState: ICom0101P4State = {
    deptTree : [],
    treeKey : '',
    maxLvlCd : '',

    /* 조회조건 */
    inquiryCnds: {
        deptCd : '',     // 부서코드
        userStCd : 'A'   // 부서상태코드
    },
}

export const com0101p4_Slice = createSlice({
    name: "com0101p4_Slice",
    initialState: initialState,
    reducers: {
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setDeptTree: (state, action:PayloadAction<IDeptTreeState[]>) => {
            state.deptTree = action.payload;
        },
        setTreeKey: (state, action:PayloadAction<string>) => {
            state.treeKey = action.payload;
        },
        setMaxLvlCd: (state, action:PayloadAction<string>) => {
            state.maxLvlCd = action.payload;
        },
    },
});

export default com0101p4_Slice.reducer;
export const Com0101p4Action  = com0101p4_Slice.actions;
export const Com0101p4Reducer = com0101p4_Slice.reducer;